// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { NamedRef } from './namedRef.zod.ts';
import { PersonRef } from './personRef.zod.ts';

export const RunSummaryOut = zod.object({
  "client": zod.string(),
  "country": zod.union([zod.string(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([PersonRef,zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "industry": zod.union([NamedRef,zod.null()]),
  "match_count": zod.int(),
  "problem_excerpt": zod.string(),
  "status": zod.string(),
  "top_match": zod.union([zod.string(),zod.null()]),
  "top_total": zod.union([zod.int(),zod.null()])
});

export type RunSummaryOut = zod.input<typeof RunSummaryOut>;
export type RunSummaryOutOutput = zod.output<typeof RunSummaryOut>;
